var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63213 20V9.20483H4.20235V20H7.63213ZM5.91768 7.73004C7.11371 7.73004 7.85817 6.9011 7.85817 5.8652C7.83589 4.80594 7.11375 4 5.94038 4C4.76719 4 4 4.80595 4 5.8652C4 6.90115 4.74428 7.73004 5.89529 7.73004H5.91758H5.91768ZM9.53049 20H12.9603V13.9714C12.9603 13.6488 12.9825 13.3265 13.0731 13.0959C13.3211 12.4512 13.8854 11.7836 14.8328 11.7836C16.0739 11.7836 16.5704 12.7735 16.5704 14.2247V19.9999H20V13.8101C20 10.4942 18.3079 8.95139 16.0513 8.95139C14.2011 8.95139 13.3888 10.0333 12.9374 10.7702H12.9603V9.2046H9.53057C9.57558 10.2176 9.53057 19.9998 9.53057 19.9998L9.53049 20Z",
    fill: "#051655"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedIn);
export default __webpack_public_path__ + "static/media/socialLinkedIn.eccc6fe15ac654187e20e50ee61eff04.svg";
export { ForwardRef as ReactComponent };